import { ExternalLink, Plus, Minus } from "lucide-react";
import { TAG_BY_ID, TagIcon, normalizeDietary } from "@/lib/dietaryTags";

function DietBadges({ ids }) {
  const list = normalizeDietary(ids);
  if (!list.length) return null;
  return (
    <span className="inline-flex items-center gap-1.5 flex-wrap">
      {list.map((id) => {
        const meta = TAG_BY_ID[id];
        if (!meta) return null;
        return (
          <span
            key={id}
            className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-[0.08em] rounded-full px-2 py-0.5"
            style={{ color: meta.color, background: `${meta.color}14`, border: `1px solid ${meta.color}33` }}
          >
            <TagIcon id={id} size={10} /> {meta.short}
          </span>
        );
      })}
    </span>
  );
}

export function Dish({ it, sym, qty, onAdd, onDec }) {
  const tags = normalizeDietary(it.dietary);
  return (
    <div className="bg-white rounded-xl border border-border p-4 flex gap-4" data-testid={`dish-${it.id}`}>
      {it.photo && (
        <div className="w-20 h-20 rounded-lg overflow-hidden bg-muted shrink-0">
          <img src={it.photo} alt="" className="w-full h-full object-cover" />
        </div>
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-2 min-w-0 flex-1">
            {tags.slice(0, 2).map((id) => <TagIcon key={id} id={id} size={14} />)}
            <h3 className="font-heading font-semibold text-[15px] leading-tight break-words">{it.name}</h3>
          </div>
          <div className="font-heading font-bold brand-orange whitespace-nowrap">{sym}{Number(it.price).toFixed(2)}</div>
        </div>
        {it.description && (
          <p className="text-sm text-foreground/60 mt-1 leading-relaxed break-words">{it.description}</p>
        )}
        {tags.length > 0 && <div className="mt-2"><DietBadges ids={tags} /></div>}
        <div className="mt-3 flex items-center justify-between gap-3">
          {it.video_url ? (
            <a href={it.video_url} target="_blank" rel="noreferrer" className="text-xs font-semibold brand-orange inline-flex items-center gap-1">
              Watch video <ExternalLink className="w-3 h-3" />
            </a>
          ) : <span />}
          {qty > 0 ? (
            <div className="inline-flex items-center gap-2 rounded-full border border-brand-orange bg-brand-orange/5 px-2 py-1">
              <button onClick={() => onDec(it)} aria-label="Remove one" className="w-7 h-7 rounded-full bg-white border border-brand-orange brand-orange flex items-center justify-center" data-testid={`cart-dec-${it.id}`}>
                <Minus className="w-3.5 h-3.5" />
              </button>
              <span className="font-bold brand-orange text-sm min-w-[20px] text-center" data-testid={`cart-qty-${it.id}`}>{qty}</span>
              <button onClick={() => onAdd(it)} aria-label="Add one" className="w-7 h-7 rounded-full bg-brand-orange text-white flex items-center justify-center" data-testid={`cart-inc-${it.id}`}>
                <Plus className="w-3.5 h-3.5" />
              </button>
            </div>
          ) : (
            <button
              onClick={() => onAdd(it)}
              className="inline-flex items-center gap-1 rounded-full border border-brand-orange brand-orange bg-white hover:bg-brand-orange hover:text-white transition text-xs font-bold px-3 py-1.5"
              data-testid={`cart-add-${it.id}`}
            >
              <Plus className="w-3.5 h-3.5" /> Add
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
